/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log( 'Hello World! (from so-hero-block-so-hero-block block)' );
/* eslint-enable no-console */


document.addEventListener("DOMContentLoaded", function (event) {

  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener("load", function (e) {

    const videoPopUpButton = document.querySelector('.hero-video-pop-up-button');
    const downCarat = document.querySelector('.down-carat');
    const unleashCircle = document.querySelector('.unleash-circle');

    //custom GSAP code goes here

    gsap.to('.wp-block-so-hero-block-so-hero-block', {
      autoAlpha: 1,
      delay: 0
    });

    if (this.document.querySelector('.breadcrumb')) {
      gsap.from('.breadcrumb', {
        autoAlpha: 0,
        delay: 1
      });
    }

    gsap.from('.hero-img', {
      y: -50,
      autoAlpha: 0,
      duration: .5,
      ease: 'power1',
      delay: 0.6
    });

    gsap.from('.hero-bg-1', {
      y: -50,
      autoAlpha: 0,
      duration: .5,
      ease: 'power1',
      delay: 0.8
    });

    gsap.from('.hero-bg-2', {
      y: -50,
      autoAlpha: 0,
      duration: .5,
      ease: 'power1',
      delay: 1
    });

    gsap.from('.hero-copy', {
      y: -50,
      autoAlpha: 0,
      duration: .5,
      ease: 'power1',
      delay: 1
    });

    if (this.document.querySelector('.hero-sub-copy')) {
      gsap.from('.hero-sub-copy', {
        y: -50,
        autoAlpha: 0,
        duration: .5,
        ease: 'power1',
        delay: 1.3
      });
    }

    if (this.document.querySelector('.hero-sub-copy-small')) {
      gsap.from('.hero-sub-copy-small', {
        y: -50,
        autoAlpha: 0,
        duration: .5,
        ease: 'power1',
        delay: 1.3
      });
    }

    if (videoPopUpButton) {
      gsap.from(videoPopUpButton, {
        autoAlpha: 0,
        y: -30,
        delay: 1.3
      });
    }

    if (downCarat) {
      gsap.from(downCarat, {
        autoAlpha: 0,
        y: -30,
        delay: 1
      });
    }
    if (unleashCircle) {
      gsap.from(unleashCircle, {
        autoAlpha: 0,
        rotateX: -30,
        delay: 1.5
      });
    }

    //pop-up video:

    const videoPopUpOverlay = document.querySelector('.hero-video-pop-up-overlay');
    let videoPopUpCloseOverlayButton;
    let videoPopUp;
    if (videoPopUpOverlay) {
      videoPopUpCloseOverlayButton = videoPopUpOverlay.querySelector('.close-overlay');
      videoPopUp = videoPopUpOverlay.querySelector('video');

      videoPopUpButton.addEventListener("click", event => {
        videoPopUpOverlay.classList.add('show-overlay');
        videoPopUp.play();
      });

      videoPopUpCloseOverlayButton.addEventListener("click", event => {
        videoPopUpOverlay.classList.remove('show-overlay');
        videoPopUp.pause();
      });

      videoPopUpOverlay.addEventListener("click", event => {
        if (event.target.localName !== "video") {
          videoPopUpOverlay.classList.remove('show-overlay');
          videoPopUp.pause();
        }
      });

    }

    //anchor link:
    const portfolio = document.querySelector('.portfolio');

    if (downCarat) {
      downCarat.addEventListener("click", () => {
        window.scrollTo({ top: portfolio.offsetTop, behavior: 'smooth' });
      });
    }

  }, false);


  //hero bg carousel
  const heroCarousel = document.querySelector('.hero-bg-carousel-wrapper');

  if (heroCarousel) {

    const carouselSpeed = heroCarousel.dataset.carouselSpeed;

    let currentSlideIndex = 0;
    const slides = document.querySelectorAll('.hero-bg-carousel-slide');

    slides.forEach((slide, index) => {
      if (index !== 0) {
      slide.style.opacity = 0;
      }
    });

    setInterval(() => {
      const currentSlide = slides[currentSlideIndex];
      const nextSlideIndex = (currentSlideIndex + 1) % slides.length;
      const nextSlide = slides[nextSlideIndex];

      gsap.to(currentSlide, { opacity: 0, duration: 0.5 });
      gsap.to(nextSlide, { opacity: 1, duration: 0.5 });

      currentSlideIndex = nextSlideIndex;
    }, carouselSpeed);

  }

  //ios low power auto-play workaround:
  const heroBgVideo = document.querySelector('.hero-img video');
  if (heroBgVideo) {
    document.addEventListener('touchstart', () => {

      if (heroBgVideo.currentTime > 0) {
        return;
      }

      return heroBgVideo.play();
    })
  }

});